import { observer } from 'mobx-react-lite';
import { View } from 'react-native';

import { StyledCardContent } from '../SeenThings';
import { useSeenThingsPresenter } from '../SeenThingsPresenter';
import SeenThingsBrandCard from './SeenThingsBrandCard';

const SeenThingsByBrand = () => {
  const { openBrandDetails, productsByBrand } = useSeenThingsPresenter();

  return (
    <View>
      <StyledCardContent>
        {productsByBrand?.map((item) => (
          <SeenThingsBrandCard
            onPress={() => {
              openBrandDetails(item);
            }}
            item={item}
            name={item.brand}
            key={item.brand}
          />
        ))}
      </StyledCardContent>
    </View>
  );
};

export default observer(SeenThingsByBrand);
